<template>
	<div class="sign-bottom-content">
		<div class="first-line">
			<img src="@/assets/img/bottom-log.png"/>
			<span>开启互联网签约新篇章</span>	
		</div>
		<div class="second-line">
			<span @click="official_website">返回官网</span>
			<span @click="About_my">关于我们</span>
			<span @click="Use_help">使用帮助</span>
			<span @click="Service_agreement">服务协议</span>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				user: {
					userAccount: "",
					userPassword: ""
				},
				passw: "password",
				icon: "el-input__icon el-icon-view",
				loading: false,
			};
		},
		created() {
			var pagename_one = window.location.host
			if (pagename_one.indexOf("aiosign.com") >= 0) {
				this.new_url = 'https://' + pagename_one
			} else {
				this.new_url = this.$SIF.get_url
			}
		},
		methods: {
			official_website(){
				window.open(this.new_url+'/index.html#/home_page')
				// window.location.href='https://aiosign.com/index.html#/home_page'
			},
			About_my(){
				window.open(this.new_url+'/index.html#/about/aboutUs')
				// window.location.href='https://aiosign.com/index.html#/about/aboutUs'
			},
			Use_help(){
				window.open(this.new_url+'/index.html#/lawProtect')
				// window.location.href='https://aiosign.com/index.html#/lawProtect'
			},
			Service_agreement(){
				window.open(this.new_url+'/index.html#/about/aboutUsAddress')
				// window.location.href='https://aiosign.com/index.html#/about/aboutUsAddress'
			},
		}
	}
</script>

<style>
	.sign-bottom-content{
		-webkit-touch-callout:none;  /*系统默认菜单被禁用*/
		-webkit-user-select:none; /*webkit浏览器*/
		-khtml-user-select:none; /*早期浏览器*/
		-moz-user-select:none;/*火狐*/
		-ms-user-select:none; /*IE10*/
		user-select:none;
	}
	.sign-bottom-content{
		width: 100%;
		height: 80px;			
	}
	.sign-bottom-content .first-line{
		width:553px;
		height: 50px;
		margin: 0 auto;
		border-bottom: 2px #D6D6D6 solid;
		line-height: 50px;
		padding: 10px;
		text-align: center;
	}
	.sign-bottom-content .first-line img{
		width:77px;
		height: 22px;
		display: inline-block;
	}
	.sign-bottom-content .first-line span{		
		font-size:14px;
		font-family:SourceHanSansCN-Light,SourceHanSansCN;
		font-weight:300;
		color:rgba(81,81,81,1);
		position: relative;
		bottom:5px;
		left:10px;
	}
	.sign-bottom-content .second-line{
		width:553px;
		height: 38%;
		margin: 0 auto;
		line-height: 30px;
		text-align: center;
		cursor: pointer;
	}
	.sign-bottom-content .second-line span{
		font-size:14px;
		font-family:SourceHanSansCN-Light,SourceHanSansCN;
		font-weight:300;
		color:rgba(81,81,81,1);
		margin-right:40px ;
	}
	.sign-bottom-content .second-line span:hover{
		color: #0FC87D;
	}
</style>